import { useLang } from '../../contexts/LangContext'

interface OnboardingProgressProps {
  currentStep: number
  stepLabels: string[]
}

export default function OnboardingProgress({ currentStep, stepLabels }: OnboardingProgressProps) {
  const { t } = useLang()

  return (
    <section className="rounded-[1.75rem] border border-slate-200 bg-white p-6 shadow-sm">
      <p className="text-xs font-semibold uppercase tracking-[0.22em] text-slate-400">
        {t('Βήμα', 'Step')} {Math.min(currentStep + 1, stepLabels.length)} / {stepLabels.length}
      </p>

      <div className="mt-6 space-y-4">
        {stepLabels.map((label, index) => {
          const completed = index < currentStep
          const active = index === currentStep

          return (
            <div key={label} className="flex items-center gap-4">
              <span
                className={[
                  'flex h-10 w-10 shrink-0 items-center justify-center rounded-full border text-sm font-bold transition-colors',
                  completed ? 'border-emerald-500 bg-emerald-500 text-white' : '',
                  active ? 'border-primary-600 bg-primary-50 text-primary-700' : '',
                  !completed && !active ? 'border-slate-200 bg-slate-50 text-slate-400' : '',
                ].join(' ')}
              >
                {index + 1}
              </span>
              <div className="min-w-0">
                <p className="text-sm font-semibold text-slate-900">{label}</p>
                <div className="mt-2 h-1.5 rounded-full bg-slate-100">
                  <div
                    className={[
                      'h-full rounded-full transition-all',
                      completed ? 'w-full bg-emerald-500' : '',
                      active ? 'w-2/3 bg-primary-500' : '',
                      !completed && !active ? 'w-0' : '',
                    ].join(' ')}
                  />
                </div>
              </div>
            </div>
          )
        })}
      </div>
    </section>
  )
}
